<template>
    <v-dialog v-model="shows" width="1280" persistent :fullscreen="$vuetify.breakpoint.mobile">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card light v-bind="{ loading }" tile class="d-flex flex-column" max-height="90vh" style="overflow: hidden">
            <v-card-title>
                <span> 자재명세서 업로드 </span>

                <v-file-btn v-model="excelFile" accept=".xlsx,.xls" x-small tile color="green white--text" class="my-n1 ml-2"> <v-icon small class="mr-2">mdi-microsoft-excel</v-icon> 파일 업로드 </v-file-btn>

                <v-spacer />
                <v-icon @click="shows = false">mdi-close</v-icon>
            </v-card-title>
            <v-divider />
            <v-card-text class="py-5" style="position: relative; flex: 0 1 auto; overflow-y: auto">
                <mes-bom-form :value="form" isCreate />
                <v-fade-transition>
                    <v-overlay v-show="!excelFile" absolute light color="white">
                        <span class="text-h6 black--text">엑셀파일을 업로드 해주세요</span>
                    </v-overlay>
                </v-fade-transition>
                <v-fade-transition>
                    <v-overlay v-show="loading" absolute light color="white">
                        <v-progress-circular indeterminate size="100" width="5" color="primary" />
                    </v-overlay>
                </v-fade-transition>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn text color="primary" @click="save">저장</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import { initManufacturingBom, initManufacturingBomRow } from "@/assets/variables";
import MesBomForm from "./mes-bom-form.vue";
import VFileBtn from "@/components/plugins/vuetify/v-file-btn.vue";

export default {
    components: {
        MesBomForm,
        VFileBtn,
    },
    data: () => ({
        excelFile: null,
        excelJSON: null,
        excelSheet: null,

        shows: false,
        loading: false,
    }),
    computed: {
        form() {
            return {
                bom: initManufacturingBom({
                    MODEL_CODE: this.excelSheet?.E2?.w || "-",
                    MODEL_NAME: this.excelSheet?.E3?.w || "-",
                    REVISION: this.excelSheet?.E4?.w || "-",
                    ECO_DATE: this.excelSheet?.N3?.w || this.$dayjs().format("YYYY-MM-DD"),
                    DATE_FR: this.excelSheet?.N3?.w || this.$dayjs().format("YYYY-MM-DD"),
                    DATE_TO: "2099-12-31",
                }),
                rows: (this.excelJSON || []).map((row) =>
                    initManufacturingBomRow({
                        ROW_NUM: row?.B || "-",
                        ITEM_LEVEL: [row?.C || null, row?.D || null, row?.E || null, row?.F || null, row?.G || null, row?.H || null],
                        WORK_SIDE: row?.I ? "TOP" : row?.J ? "BOT" : "-",
                        ITEM_CODE: row?.K || "-",
                        REVISION: row?.L || "-",
                        RANK: row?.M || "-",
                        ITEM_NAME: row?.N || "-",
                        ITEM_NAME: row?.N || "-",
                        SPEC: row?.O || "-",
                        CIRCUIT_NO: row?.P || "-",
                    })
                ),
            };
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
        excelFile() {
            if (!this.excelFile) {
                this.excelJSON = null;
                this.excelSheet = null;
                return;
            }

            if (this.loading) return;
            else this.loading = true;

            const reader = new FileReader();
            reader.onload = async () => {
                const workBook = XLSX.read(reader.result, { type: "binary" });

                this.excelSheet = workBook.Sheets[workBook.SheetNames[0]];
                this.excelJSON = XLSX.utils.sheet_to_json(this.excelSheet, { range: 7, header: "A" });

                this.loading = false;
            };

            reader.readAsBinaryString(this.excelFile);
        },
    },
    methods: {
        init() {
            this.excelFile = null;
            this.excelJSON = null;
        },
        validates() {},
        async save() {
            if (this.loading) return;
            else this.loading = true;

            try {
                this.validates();

                await api.console.mes.boms.excel.post(this.excelFile);

                alert("업로드되었습니다");
                this.$emit("input");
                this.shows = false;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .text-align-right-field {
    & > .v-input__control > .v-input__slot > .v-text-field__slot > input {
        text-align: right !important;
    }
}
::v-deep .amount-field {
    & > .v-input__control > .v-input__slot {
        padding-right: 0 !important;
    }
    & > .v-input__control > .v-input__slot > .v-input__append-inner {
        margin: 1px 0 0;
    }
    & > .v-input__control > .v-input__slot > .v-input__append-inner > .v-text-field--solo {
        width: 58px !important;

        .v-input__slot {
            padding-right: 4px;
        }
        .v-select__selections {
            justify-content: center;

            > .v-select__selection {
                margin-right: 0;
            }

            > input {
                display: none;
            }
        }

        .v-input__control,
        .v-input__slot {
            background-color: transparent;
        }
        .v-input__append-inner {
            margin-top: 0;
            padding-left: 0;
        }
    }
}

::v-deep .v-text-field__details {
    margin-bottom: 0 !important;
}

::v-deep .w-100-px {
    width: 100px;
}
</style>
